export interface GroupOption {
  group: string;
  options: any[];
}
